import styled from 'styled-components'
import CommonButton from 'components/Button/CommonButton'
import { CommonLinkButton } from 'components/Button'
import theme from 'theme_'
import { H4 } from 'components/Typography'
import { NetworkWizardContainer, NetworkWizardWhiteBlock } from '../styles'

export const ClaimDeviceContainer = styled(NetworkWizardContainer)`
  gap: 16px;
`

export const ClaimDeviceWhiteBlock = styled(NetworkWizardWhiteBlock)`
  width: 100%;
  padding: 54px ${theme.spacing.base};
  gap: ${theme.spacing.lg};
  min-height: 572px;
  justify-content: space-between;
`

export const ClaimDeviceH4 = styled(H4)`
  @media ${theme.devices.tablet} {
    font-size: 20px;
  }
`

export const ClaimDeviceSecondaryButton = styled(CommonButton)`
  background: transparent;
  min-width: 186px;
  height: 40px;
`

export const ClaimDeviceInputControlContainer = styled.div`
  max-width: 320px;
`
export const ClaimDeviceHelperButton = styled(CommonLinkButton)`
  display: flex;
  font-size: 14px;
  justify-content: flex-start;
  color: ${theme.colors.otterWarmBlack};
`

export const DisplayCodeHelper = styled.img`
  flex-shrink: 1;
  width: 100%;
`
